import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { GAClickButton } from 'utils/analytics';
import { selectPageModelTitle } from '../../../store/pageModel';
import { selectSelectedStoreCode, selectSelectedStoreData, selectStores } from '../selectors';
import { useInstoreSlice } from './use-instore-slice';

export const useInstore = () => {
	useInstoreSlice();

	const title = useSelector(selectPageModelTitle);
	const stores = useSelector(selectStores);
	const selectedStoreCode = useSelector(selectSelectedStoreCode);
	const selectedStoreData = useSelector(selectSelectedStoreData);

	const [isModalOpen, setIsModalOpen] = useState(false);

	const openModal = useCallback(() => {
		setIsModalOpen(true);
	}, []);

	const closeModal = useCallback(() => {
		setIsModalOpen(false);
		GAClickButton({
			elementBlock: 'servicePage',
			elementName: `${title} / modal`,
			elementText: 'Закрыть',
		});
	}, [title]);

	return {
		isModalOpen,
		openModal,
		closeModal,
		selectedStoreCode,
		selectedStoreData,
		stores,
	};
};
